import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import WebViewerServersTable from '../components/webViewerServersTable';
import OverlayLoader from '../components/overlayLoader';
import TableSelectionManager from '../components/tableSelectionManager';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import * as objectDataActions from '../store/objectDataSlice';
import { objectDataNames, objectDataSelectors } from '../store/objectDataSlice';
import WebViewerServerAddDialog from './webViewerServerAddDialog';
import WebViewerLicenseEditDialog from './webViewerLicenseEditDialog';
import WebViewerServerHistoryDialog from './webViewerServerHistoryDialog';
import RemoveRestoreWebViewerServersConfirmDialog from './removeRestoreWebViewerServersConfirmDialog';
import DeactivateWebViewerServerConfirmDialog from './deactivateWebViewerServerConfirmDialog';
import ReactivateWebViewerServerDialog from './reactivateWebViewerServerDialog';
import ModalMessage from './modalMessage';
import setTitleToFilters from '../common/filtersTitles';

import './common.css';
import { userConfigsSelectors } from '../store/userConfigs';

const thatObjectName = 'webViewerServers';

class WebViewerServersContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showWebViewerServerAddDialog: false,
      webViewerServerAddDialogMode: WebViewerServerAddDialog.Mode.Create,
      showWebViewerLicenseEditDialog: false,
      webViewerLicenseEditDialogMode: WebViewerLicenseEditDialog.Mode.Create,
      showHistoryDialog: false,
      showRemoveRestoreWebViewerServersConfirmDialog: false,
      removeRestoreWebViewerServersConfirmDialogMode: null,
      showDeactivateWebViewerServerConfirmDialog: false,
      showReactivateWebViewerServerDialog: false,
    };
  }

  componentDidMount() {
    setTitleToFilters();
    this.props.fetchAllWebViewerServers();
    this.props.fetchLivingStates();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Web viewer servers</h1>
          {this.renderButtons()}
          {this.renderContent()}
          {this.renderWebViewerServerAddDialog()}
          {this.renderWebViewerLicenseEditDialog()}
          {this.renderHistoryDialog()}
          {this.renderModalMessage()}
          {this.renderRemoveRestoreWebViewerServersConfirmDialog()}
          {this.renderDeactivateWebViewerServerConfirmDialog()}
          {this.renderReactivateWebViewerServerDialog()}
        </div>
      </OverlayLoader>
    );
  }

  renderModalMessage = () => <ModalMessage />;

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement type="button" text="Refresh" icon="refresh" onClick={this.props.fetchAllWebViewerServers} />
      <TooltipElement type="button" text="Create web viewer server" icon="plus" onClick={this.createNewWebViewerServer} displayOnlyForWriter />
      <TooltipElement type="button" text="Edit web viewer server" icon="edit" onClick={this.editWebViewerServer} disabled={this.isEditWebViewerServerButtonDisabled()} displayOnlyForWriter />
      <TooltipElement type="button" text="Deactivate web viewer server" icon="off" onClick={this.deactivateWebViewerServer} disabled={this.isDeactivateButtonDisabled()} displayOnlyForWriter />
      <TooltipElement type="button" text="Reactivate web viewer server" icon="share-alt" onClick={this.reactivateWebViewerServer} disabled={this.isReactivateButtonDisabled()} displayOnlyForWriter />
      <TooltipElement type="button" text="Remove web viewer server" icon="remove" onClick={this.removeWebViewerServers} disabled={this.isRemoveButtonDisabled()} displayOnlyForWriter />
      <TooltipElement type="button" text="Restore web viewer server" icon="repeat" onClick={this.restoreWebViewerServers} disabled={this.isRestoreButtonDisabled()} displayOnlyForWriter />
      <TooltipElement type="button" text="Create web viewer license" icon="plus-sign" disabled={this.isCreateWebViewerLicenseButtonDisabled()} onClick={this.createNewWebViewerLicense} displayOnlyForWriter />
      <TooltipElement type="button" text="Show web viewer server history" icon="list-alt" onClick={this.showWebViewerServerHistory} disabled={this.isHistoryButtonDisabled()} />
    </TooltipButtonGroup>
  );

  getActionsForFavorites = () => ({
    addToFavorites: this.props.addWebViewerServerToFavorites,
    removeFromFavorites: this.props.removeWebViewerServerFromFavorites,
  });

  renderContent = () => {
    if (this.props.webViewerServersFetchingError)
      return this.renderError(this.props.webViewerServersFetchingError.toString());
    return (
      <TableSelectionManager
        items={this.props.webViewerServers}
        objectName={thatObjectName}
      >
        <WebViewerServersTable
          webViewerServers={this.props.webViewerServers}
          livingStates={this.props.livingStatesState.data}
          serverTypes={this.props.serverTypes}
          actions={this.getActionsForFavorites()}
          requestData={this.props.requestData}
        />
      </TableSelectionManager>
    );
  };

  renderError = (message) => <p className="text-danger">Error: {message}</p>;

  isLoading = () => this.props.isWebViewerServersFetching ||
    this.props.livingStatesState.isFetching;

  getLoaderMessage = () => {
    if (this.props.isWebViewerServersFetching) {
      return 'Web viewer servers loading...';
    }
    if (this.props.livingStatesState.isFetching) {
      return 'Web viewer server living states loading...';
    }
  };

  renderWebViewerServerAddDialog = () => (
    <WebViewerServerAddDialog
      mode={this.state.webViewerServerAddDialogMode}
      onClose={this.closeWebViewerServerAddDialog}
      show={this.state.showWebViewerServerAddDialog}
      serverId={this.getSelectedWebViewerServerFieldValue('id')}
      connectionCount={this.getSelectedWebViewerServerFieldValue('connectionCount')}
      type={this.getSelectedWebViewerServerFieldValue('type')}
      term={this.getSelectedWebViewerServerFieldValue('term')}
      generationDate={this.getSelectedWebViewerServerFieldValue('generationDateTime')}
      linkConnectionCount={this.getSelectedWebViewerServerFieldValue('linkConnectionCount')}
      connectionSharingPolicy={this.getSelectedWebViewerServerFieldValue('connectionSharingPolicy')}
      linkCount={this.getSelectedWebViewerServerFieldValue('linkCount')}
    />
  );

  closeWebViewerServerAddDialog = () => {
    this.setState({ showWebViewerServerAddDialog: false });
  };

  createNewWebViewerServer = () => {
    this.setState({
      webViewerServerAddDialogMode: WebViewerServerAddDialog.Mode.Create,
      showWebViewerServerAddDialog: true,
    });
  };

  editWebViewerServer = () => {
    this.setState({
      webViewerServerAddDialogMode: WebViewerServerAddDialog.Mode.Edit,
      showWebViewerServerAddDialog: true,
    });
  };

  isEditWebViewerServerButtonDisabled = () => {
    const servers = this.props.selectedWebViewerServers;
    return servers.length !== 1 || Boolean(servers.find((server) => server.type !== 2 && server.type !== 3));
  }

  renderWebViewerLicenseEditDialog = () => (
    <WebViewerLicenseEditDialog
      mode={this.state.webViewerLicenseEditDialogMode}
      onClose={this.closeWebViewerLicenseEditDialog}
      show={this.state.showWebViewerLicenseEditDialog}
      webViewerServerId={this.getSelectedWebViewerServerFieldValue('id')}
    />
  )

  isCreateWebViewerLicenseButtonDisabled = () => {
    const servers = this.props.selectedWebViewerServers;
    return servers.length !== 1 || servers.find((server) => server.type !== 1 && server.type !== 3);
  }

  createNewWebViewerLicense = () => {
    this.setState({
      webViewerLicenseEditDialogMode: WebViewerLicenseEditDialog.Mode.Create,
      showWebViewerLicenseEditDialog: true
    });
  }

  closeWebViewerLicenseEditDialog = () => {
    this.setState({ showWebViewerLicenseEditDialog: false });
  };

  renderRemoveRestoreWebViewerServersConfirmDialog = () => (
    <RemoveRestoreWebViewerServersConfirmDialog
      show={this.state.showRemoveRestoreWebViewerServersConfirmDialog}
      onClose={this.closeRemoveRestoreWebViewerServersConfirmDialog}
      serverIds={this.props.selectedWebViewerServersIds}
      mode={this.state.removeRestoreWebViewerServersConfirmDialogMode}
    />
  );

  isRemoveButtonDisabled = () => {
    const servers = this.props.selectedWebViewerServers;
    return servers.length === 0 || servers.find(server => !server.isAlive) !== undefined;
  };

  isRestoreButtonDisabled = () => {
    const servers = this.props.selectedWebViewerServers;
    return servers.length === 0 || servers.find(server => server.isAlive) !== undefined;
  };

  removeWebViewerServers = () => {
    this.setState({
      removeRestoreWebViewerServersConfirmDialogMode: RemoveRestoreWebViewerServersConfirmDialog.Mode.Remove,
      showRemoveRestoreWebViewerServersConfirmDialog: true,
    });
  };

  restoreWebViewerServers = () => {
    this.setState({
      removeRestoreWebViewerServersConfirmDialogMode: RemoveRestoreWebViewerServersConfirmDialog.Mode.Restore,
      showRemoveRestoreWebViewerServersConfirmDialog: true,
    });
  };

  closeRemoveRestoreWebViewerServersConfirmDialog = () => {
    this.setState({ showRemoveRestoreWebViewerServersConfirmDialog: false });
  };

  renderDeactivateWebViewerServerConfirmDialog = () => (
    <DeactivateWebViewerServerConfirmDialog
      show={this.state.showDeactivateWebViewerServerConfirmDialog}
      onClose={this.closeDeactivateWebViewerServerConfirmDialog}
      serverId={this.getSelectedWebViewerServerFieldValue('id')}
    />
  );

  isDeactivateButtonDisabled = () => {
    if (this.props.selectedWebViewerServers.length !== 1)
      return true;
    let server = this.props.selectedWebViewerServers[0];
    return !server ||
      !server.isAlive ||
      server.device === null;
  };

  deactivateWebViewerServer = () => {
    this.setState({ showDeactivateWebViewerServerConfirmDialog: true });
  };

  closeDeactivateWebViewerServerConfirmDialog = () => {
    this.setState({ showDeactivateWebViewerServerConfirmDialog: false });
  };

  renderReactivateWebViewerServerDialog = () => (
    <ReactivateWebViewerServerDialog
      show={this.state.showReactivateWebViewerServerDialog}
      onClose={this.closeReactivateWebViewerServerDialog}
      serverId={this.getSelectedWebViewerServerFieldValue('id')}
      serverKey={this.getSelectedWebViewerServerFieldValue('key')}
      deviceKey={this.getSelectedWebViewerServerFieldValue('device.key')}
    />
  );

  isReactivateButtonDisabled = () => {
    if (this.props.selectedWebViewerServers.length !== 1)
      return true;
    let server = this.props.selectedWebViewerServers[0];
    return !server ||
      !server.isAlive;
  };

  reactivateWebViewerServer = () => {
    this.setState({ showReactivateWebViewerServerDialog: true });
  };

  closeReactivateWebViewerServerDialog = () => {
    this.setState({ showReactivateWebViewerServerDialog: false });
  };

  getSelectedWebViewerServerFieldValue = (fieldName, defaultValue = null) => {
    const webViewerServer = this.props.selectedWebViewerServers[0];
    if (!webViewerServer) return null;
    try {
      const value = fieldName.split('.').reduce((acc, key) => acc[key], webViewerServer);
      return value === undefined ? defaultValue : value === null ? defaultValue : value;
    } catch (e) {
      return defaultValue;
    }
  };

  renderHistoryDialog = () => {
    return (
      <WebViewerServerHistoryDialog
        show={this.state.showHistoryDialog}
        onClose={this.closeHistoryDialog}
        id={this.getSelectedWebViewerServerFieldValue('id')}
      />
    );
  };

  showWebViewerServerHistory = () => {
    this.setState({ showHistoryDialog: true });
  };

  closeHistoryDialog = () => {
    this.setState({ showHistoryDialog: false });
  };

  isHistoryButtonDisabled = () => this.props.selectedWebViewerServers.length !== 1;
}

const mapStateToProps = (state) => ({
  isWebViewerServersFetching: webViewerServersSelectors.isFetching(state),
  webViewerServers: webViewerServersSelectors.selectAll(state),
  webViewerServersFetchingError: webViewerServersSelectors.fetchingError(state),

  livingStatesState: objectDataSelectors.webViewerServerLivingState(state),
  serverTypes: webViewerServersSelectors.state(state).serverTypes,

  selectedWebViewerServersIds: userConfigsSelectors.selectedItems(state, thatObjectName),
  selectedWebViewerServers: webViewerServersSelectors.selectedWebViewerServers(state),
});

const actionCreators = {
  fetchAllWebViewerServers: webViewerServersActions.fetchAllWebViewerServers,
  addWebViewerServerToFavorites: webViewerServersActions.addToFavorites,
  removeWebViewerServerFromFavorites: webViewerServersActions.removeFromFavorites,
  fetchLivingStates: () => objectDataActions.fetchObjectData({ objectName: objectDataNames.webViewerServerLivingStates }),
};

export default connect(mapStateToProps, actionCreators)(WebViewerServersContainer);


// WEBPACK FOOTER //
// ./src/containers/webViewerServersContainer.js